import React, { Component, Fragment } from 'react'
//import PropTypes from 'prop-types'
import Theme from "./../../assets/Theme";
import Error from "./Error"
import Rejected from "./Rejected"
import Confirmed from './Confirmed'
//import config from "./../../store/config/config.json";
import Header from './../../components/Header';
import Footer from './../../components/Footer';

//import { Container,  Typography } from '@material-ui/core';

class ThankYouPage extends Component {
    constructor(props) {
        super(props)
        this.state={
           booking: this.props.location.state.booking,
        }
    }

    componentDidMount(){
        window.scrollTo(0,0)
    }
    
    render() {

        const tokenClient = this.props.match.params.token
        let config = require(`./../../store/config/${tokenClient}/config.json`);
        const bookingState = this.state.booking

        console.log('ThankYouPage',this.state)

        return (
            <Theme>
                <div className={`wrapper checkout wrapper-${config.client.name}`}  styles={config.styles}>
                    <Header 
                    misReservas={config.misReservas} 
                    isLogin={config.credential.isLogin} 
                    client={config.client} 
                    header={config.header} 
                    />
                    <main className={`main_content`}>
                        <div className="page-maxwidth">
                        {!bookingState 
                        ? <Error 
                            content={config.booking.error} 
                            tokenClient={tokenClient}
                        /> 
                        : <Fragment>  
                                {bookingState.bookingState === "CREATED" 
                                    ? <Rejected  
                                        content={config.booking.rejected} 
                                    />
                                    : <Confirmed  
                                        content={config.booking.confirmed} 
                                        bookingReference={bookingState.bookingReference} 
                                        /* purchaseDetail={config.booking.purchaseDetail}
                                        messages={config.booking.messages} */
                                        productDetail={config.booking.productDetail}
                                        bookingItems={bookingState.bookingItems}
                                    />
                                }
                            </Fragment>}
                        </div>
                    </main>
                    <Footer data={config.footer} client={config.client} />
                </div>
             </Theme>
        )
    }
}

export default ThankYouPage